import { Component, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-dog-breed-dialog',
  templateUrl: './edit-dog-breed-dialog.component.html',
  styleUrl: './edit-dog-breed-dialog.component.scss',
})
export class EditDogBreedDialogComponent {
  readonly fb = inject(FormBuilder);
  readonly dialogData = inject<{
    id?: string;
    hu?: string;
    en?: string;
    de?: string;
    it?: string;
  }>(MAT_DIALOG_DATA);

  breedForm = this.fb.group({
    id: [this.dialogData.id],
    // hu: [this.dialogData.hu, [Validators.required]],
    en: [this.dialogData.en, [Validators.required]],
    // de: [this.dialogData.de, [Validators.required]],
    // it: [this.dialogData.it, [Validators.required]],
  });
}
